import "./garden-slider.scss";

import React, { useState, useEffect } from "react";
import { graphql, StaticQuery } from "gatsby";
import classNames from "classnames";
import Slider from "react-slick";

import useTranslation from "locales";

const GardenSlider = ({ data, lang }) => {
  const { t } = useTranslation(lang);
  const info = lang === "en" ? data.nodes[1].homePage : data.nodes[0].homePage;
  const [updated, setUpdated] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  const updateMobile = () => {
    setIsMobile(window.innerWidth < 768);
  };

  useEffect(() => {
    updateMobile();

    window?.addEventListener("resize", updateMobile);
    return () => window.removeEventListener("resize", updateMobile);
  }, []);

  const gardenSliderOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    fade: true,
    pauseOnHover: false,
    afterChange: (e) => {
      setUpdated(true);
    },
    beforeChange: (e) => {
      setUpdated(false);
    },
    responsive: [
      {
        breakpoint: 1201,
        settings: {},
      },
      {
        breakpoint: 992,
        settings: {},
      },
      {
        breakpoint: 769,
        settings: {
          dots: false,
        },
      },
      {
        breakpoint: 576,
        settings: {},
      },
    ],
  };

  return (
    <div className="garden-slider">
      <Slider {...gardenSliderOptions}>
        {info?.slides?.map((item, index) => (
          <div>
            <div
              key={index}
              className="garden-slider__slide"
              style={{
                backgroundImage: `url(${
                  isMobile
                    ? item?.mobileImage?.localFile?.publicURL
                    : item?.image?.localFile?.publicURL
                })`,
              }}
            >
              <div
                className={classNames(`slide-content`, {
                  [`slide-content--active`]: updated,
                  [`slide-content--fadeout`]: !updated,
                })}
              >
                <div className="slide-content__location">
                  <span>{t(item?.place)}</span>
                </div>
                <img
                  src={item?.logo?.localFile?.publicURL}
                  alt=""
                  className="slide-content__logo"
                />
                <div className="slide-content__info">
                  {t("Czas trwania wystawy")} <br />
                  {item?.date}
                </div>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href={t(item?.link)}
                  className="btn btn--outline slide-content__btn"
                >
                  {t("Więcej")}
                </a>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default function StaticSlider(props) {
  return (
    <StaticQuery
      query={graphql`
        {
          data: allWpPage(
            filter: { template: { templateName: { eq: "StronaGlowna" } } }
          ) {
            nodes {
              homePage {
                heroHeader
                heroDescription
                heroBackground {
                  localFile {
                    publicURL
                  }
                }
                heroBackgroundMobile {
                  localFile {
                    publicURL
                  }
                }
                slides {
                  image {
                    localFile {
                      publicURL
                    }
                  }
                  mobileImage {
                    localFile {
                      publicURL
                    }
                  }
                  logo {
                    localFile {
                      publicURL
                    }
                  }
                  place
                  date
                  link
                }
              }
              language {
                slug
              }
            }
          }
        }
      `}
      render={(data) => <GardenSlider {...data} {...props} />}
    />
  );
}
